import { useNavigate } from "react-router-dom";
import { Button, IconButton, Box } from "@mui/material";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";

/* Stats Icons */
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";

/* Zone Card Icons */
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import SearchBar from "../../components/SearchBar";
import AddZone from "../../Modals/addzone";

const DeliveryZones = () => {
    const navigate = useNavigate();

    const zones = [
        {
            id: 1,
            name: "Dubai Express Zone",
            code: "DXB-EXPRESS",
            status: "Active",
            cities: ["Dubai"],
            duration: "1–2 days",
        },
        {
            id: 2,
            name: "Abu Dhabi Zone",
            code: "AUH-STANDARD",
            status: "Active",
            cities: ["Abu Dhabi"],
            duration: "2–3 days",
        },
        {
            id: 3,
            name: "Northern Emirates",
            code: "NORTH-UAE",
            status: "Active",
            cities: [
                "Sharjah",
                "Ajman",
                "Umm Al Quwain",
                "Ras Al Khaimah",
                "Fujairah",
            ],
            duration: "2–4 days",
        },
    ];
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            {/* ---------- Page Header ---------- */}
            <div className="main_title">
                <h1>Delivery Zones</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Delivery Zones
                </p>
            </div>

            {/* ---------- Stats Cards (DESIGN UNCHANGED) ---------- */}
            <div className="stats_boxes gap_m">
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            3
                            <p>Total Zones</p>
                        </h2>
                        <figure className="blue">
                            <MapOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            7
                            <p>Cities Covered</p>
                        </h2>
                        <figure className="warning">
                            <LocationCityOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            UAE
                            <p>Coverage Area</p>
                        </h2>
                        <figure className="sucess">
                            <PublicOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>

            {/* ---------- Add Zone Button ---------- */}
            <div className="cards mt_20">

                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search orders..."
                            />
                        </Box>
                      
                    </div>
             
                </div>
                {/* ---------- Zone Cards (NEW DESIGN) ---------- */}
                <div className="zone_cards mt_20">
                    {zones.map((zone) => (
                        <div className="zone_card" key={zone.id}>
                            <div className="zone_header">
                                <h4>{zone.name}</h4>
                                <span className="zone_code">{zone.code}</span>
                            </div>

                            <span className="status_chip active">{zone.status}</span>

                            <div className="zone_info">
                                <div className="info_row">
                                    <PlaceOutlinedIcon />
                                    <p>{zone.cities.join(", ")}</p>
                                </div>

                                <div className="info_row">
                                    <AccessTimeOutlinedIcon />
                                    <p>{zone.duration}</p>
                                </div>
                            </div>

                        
                        </div>
                    ))}
                </div>
            </div>
            <AddZone
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default DeliveryZones;
